import api from '../callApi';

const createCompletePollRequest = (
    answerId,
    answerText,
    actionCompletedTime,
    skipEndCard
) => {
    return {
        answerId,
        text: answerText,
        actionCompletedTime,
        skipEndCard: skipEndCard
    };
};

const completePoll = (
    apiRequestData,
    answerId,
    answerText,
    actionCompletedTime,
    skipEndCard
) => {
    const request = {
        ...createCompletePollRequest(
            answerId,
            answerText,
            actionCompletedTime,
            skipEndCard
        ),
        ...apiRequestData
    };

    return api.post('Widget/CompletePollAsync', request).then(response => {
        return response;
    });
};

export default completePoll;



// WEBPACK FOOTER //
// ./src/utils/poll/pollApi.js